import { render, staticRenderFns } from "./MonthlyDistribution.vue?vue&type=template&id=4ad505ef&lang=pug"
import script from "./MonthlyDistribution.vue?vue&type=script&lang=js"
export * from "./MonthlyDistribution.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports